import {TableSortLabel} from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import { makeStyles } from "@material-ui/core/styles";
import React, { useState } from "react";
import { renderTableCellContent } from "./tableHelper";
import TablePaginationActions from "./tablePaginationActions";

export function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

export function getComparator(order, orderBy) {
  return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
}

export function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  container: {
    [theme.breakpoints.up("xl")]: {
      maxHeight: 600,
    },
    [theme.breakpoints.down("lg")]: {
      maxHeight: 500,
    },
  },
  paginationStyles: {
    flexWrap: "wrap",
    justifyContent: "center",
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}));

export default function CustomTable(props) {
  const {
    pagedItems = [],
    totalItems = 10,
    handleFetch,
    pageIndex,
    handleQueryUpdate,
    query,
    columns,
    headStyle,
    searchValue = "",
    paginationEnabled = true,
    sortingEnabled = false,
    containerStyles,
    handleSort
  } = props;
  const classes = useStyles();

  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('Name');
  const [pageSize, setPageSize] = useState(10);
  const [pageIndexLocal, setPageIndex] = useState(pageIndex - 1);

  const handleChangePage = (event, newPage) => {
    setPageIndex(newPage);
    handleQueryUpdate({ ...query, searchTerm: searchValue, pageNumber: ++newPage, pageSize });
    handleFetch();
  };

  const handleChangeRowsPerPage = (e) => {
    const pageSize = e.target.value;
    setPageSize(pageSize);
    handleQueryUpdate({ ...query, pageSize, searchTerm: searchValue });
    handleFetch();
  };

  const createSortHandler = (property) => (event) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
    handleSort(order, orderBy);
  };

  return (
    <Paper className={classes.root} style={containerStyles}>
      <TableContainer className={paginationEnabled ? classes.container : null}>
        <Table stickyHeader aria-label="sticky table" className={classes.root}>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={headStyle}
                >

                  {!sortingEnabled && column.label}
                  {sortingEnabled &&
                    <TableSortLabel
                        active={orderBy === column.id}
                        direction={orderBy === column.id ? order : 'asc'}
                        onClick={createSortHandler(column.id)}
                    >
                      {column.label}
                      {orderBy === column.id ? (
                          <span className={classes.visuallyHidden}>
                  </span>
                      ) : null}
                    </TableSortLabel>
                  }
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {pagedItems.map((row, index) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                  {columns.map((column) => (
                    <TableCell key={column.id} align={column.align}>
                      {column.link && row[column.id] && <a  href={renderTableCellContent(row, column)} target={"_blank"} >{column.render  ? column.render(row[column.id]) : renderTableCellContent(row, column)}</a> }
                      {column.link && !row[column.id] && "N/A" }
                      {!column.link && renderTableCellContent(row, column)}
                    </TableCell>
                  ))}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {paginationEnabled && (
        <TablePagination
          rowsPerPageOptions={[10, 20, 30, 40, 50]}
          component="div"
          count={totalItems}
          rowsPerPage={pageSize}
          page={pageIndexLocal}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          ActionsComponent={TablePaginationActions}
        />
      )}
    </Paper>
  );
}
